import React from 'react';

import SvgIcon from '@mui/material/SvgIcon';

export const CustomTwitterShare = (props: {}): JSX.Element => (
    <SvgIcon {...props}>
        <path
            d={
                'M12 2.59L17.7 8.29L16.29 9.71L13 6.41V16H11V6.41L7.7 9.71L6.29 8.29L12 2.59ZM21 15L20.98 18.51C20.98 19.89 19.86 21 18.48 21H5.5C4.11 21 3 19.88 3 18.5V15H5V18.5C5 18.78 5.22 19 5.5 19H18.48C18.76 19 18.98 18.78 18.98 18.5L19 15H21Z'
            }
        />
    </SvgIcon>
);
